
export default {
  name: 'show-inventaire',
  components: {},
  props: [],
  data () {
    return {
        filter: "",
        perPage: 10,
        fields: ['article', 'nombre', 'actions'], 
        nombre: 0,


    }
  },
  computed: {
    inventaire() {
        return this.$store.getters['inventaire']
    },
  },
  mounted () {
    this.$store.dispatch("getInventaire", this.$route.params.id)

  },
  methods: {

  }
}


